<template>
  <div class="col-12 mt-3">
    <transition
      tag="div"
      name="slide"
    >
      <div v-if="showCompany">
        <button
          type="button"
          class="form-control bg-gray-300 border-0 py-0 d-flex w-100"
          style="min-height:78px; border-radius: 45px;"
          @click.once="next"
        >
          <div class="d-flex flex-row my-auto w-100 px-2">
            <div class="d-flex flex-column justify-content-center">
              <div class="d-flex text-start fw-bold">
                {{ company.name }} - {{ company.siret }}
              </div>
            </div>
            <div
              class="d-flex ms-auto"
              @click.stop="removeCompany"
            >
              <font-awesome-icon
                class="d-flex m-auto p-1 cursor-pointer"
                icon="times"
                style="width:32px; height: 32px"
              />
            </div>
          </div>
        </button>
      </div>
    </transition>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import { ui, routing } from '@/mixins';
import { validateSiret } from '@/utils/validators';

export default {
  mixins: [ui, routing],
  computed: {
    ...mapGetters({
      company: 'companies/company',
      showModal: 'ui/showModal',
      focusScreen: 'ui/focusScreen',
    }),
    /**
     * Tells if company can be displayed or not
     */
    showCompany() {
      if (this.company === null) {
        return false;
      }
      return (this.company.siret && validateSiret(this.company.siret))
        && this.company.name
        && this.company.name.length > 0;
    },
  },
  methods: {
    // clear risk and client store
    removeCompany() {
      this.$store.dispatch('companies/clearCompany');
      this.$emit('remove-company');
      this.ui_showToast({ show: true, message: 'Entreprise retirée' });
    },
    next() {
      return this.$router.push('/client/account/companies/add/new');
    },
  },
};
</script>
